import React from 'react';
import { useTranslation } from 'react-i18next';
import { nl2br } from '../common/Utils';
import PaginateTotal from '../common/PaginateTotal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import moment from 'moment';

function EnforcementNewsTable(props) {
    const { t } = useTranslation();
    const { items, pageNo, pageSize, total, handlePageChange } = props;

    if (items === null) {
        return (
            <p>Loading Enforcement news ...</p>
        );
    } else {
        return (
            <div className="table-container main-style enforcement-news-table">
                <table>
                    <tbody>
                        <tr>
                            <th width='200px'>
                                <a>{t('enforcement.table.header.date')}</a>
                            </th>
                            <th>
                                <a>{t('enforcement.table.header.target-ce')}</a>
                            </th>
                            <th>
                                <a>{t('enforcement.table.header.action')}</a>
                            </th>
                        </tr>
                    </tbody>
                    <tbody>
                    {items.map((news) => {
                        const docUrl = `doc?refNo=${news.newsRefNo}`;
                        return (
                        <tr key={news.newsRefNo}>
                            <td>
                                {t('common:date.formatter',{date: moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                            </td>
                            <td>
                                <TargetCeListColumn 
                                    list={news.targetCeList}
                                    handleNameSearch={props.handleNameSearch}/>
                            </td>
                            <td>
                                <Link to={docUrl} dangerouslySetInnerHTML={{ __html:nl2br(news.title)}}></Link>
                            </td>
                        </tr>
                        );
                    })}
                    </tbody>
                </table>
                <div className="pagination-toolbar">
                    <PaginateTotal pageNo={pageNo} pageSize={pageSize} total={total} />
                    <div className="pagination-toolbar pagebar">
                        <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel={'. . .'}                                        
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={7}
                            initialPage={pageNo}
                            disableInitialCallback={true}
                            pageCount={Math.ceil(total/pageSize)}
                            onPageChange={handlePageChange}
                            containerClassName={'pagination'}
                            previousClassName={'previous'}
                            breakClassName={'break'}
                            pageClassName={'page'}
                            activeClassName={'active'}
                            nextClassName={'next'}/>
                    </div>                        
                </div>
            </div>
        );
    }
}

function TargetCeListColumn(props) {
    const { t } = useTranslation();
    const { list } = props;

    if (Array.isArray(list) && list.length > 0 ) {
        return (
            <ul>
                {list.map((target) => {
                    const items = [];
                    items.push(
                        <Link onClick={(e) => {props.handleNameSearch(e,target.ceName)}}>{target.ceName}</Link>
                    );
                    if (target.masked) {
                        items.push(t('enforcement.label.note1'));
                    }
                    return (
                        <li>{items}</li>
                    );
                })}
            </ul>
        );
    } else {
        return (
            t('enforcement.label.notApplicable')  
        );
    }
}

export default EnforcementNewsTable;